export default "__VITE_ASSET__9722ef89__"